import { render, staticRenderFns } from "./progTask.vue?vue&type=template&id=50f8c9f0"
import script from "./progTask.vue?vue&type=script&lang=js"
export * from "./progTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports